import { BaseAction } from './BaseAction';
import { MessagingEngine } from '../engines/MessagingEngine';
export class MessagingAction extends BaseAction {
    execute() {
        var _a, _b;
        // Messaging works only for logged-in users — mirrors v2: if(User.notLoggedIn()) return;
        if (!MessagingEngine.isUserLoggedIn()) {
            return false;
        }
        // Render the template HTML into the DOM — mirrors v2: super.executeAction()
        this.renderTemplate();
        // Find the rendered root element.
        // v2 uses actionTemplate.getElement() — the root element of the rendered template.
        // In the SDK, renderTemplate() injects the HTML; we find the root by locating
        // the messages container and walking up to the Mg2-connext wrapper.
        const messagesContainer = document.querySelector('[data-mg2-container="messages"]');
        if (!messagesContainer)
            return true;
        // Walk up to the Mg2-connext root — this is what v2's actionTemplate.getElement() returns
        const templateRoot = (_b = (_a = messagesContainer.closest('.Mg2-connext')) !== null && _a !== void 0 ? _a : messagesContainer.parentElement) !== null && _b !== void 0 ? _b : document.body;
        MessagingEngine.loadAndRender(templateRoot).catch(err => console.error('[MessagingAction] loadAndRender failed', err));
        return true;
    }
}
